<template>
  <div class="novedades">
    <Titulo titulo="Reporte de novedades" />
    <div class="margin-lateral">
      <b-row>
        <b-col cols="12" md="8">
          <div style="margin: -1% 3% -5% -10% !important">
            <b-form @submit.prevent="onSubmit" @reset="onReset">
              <div>
                <h4 class="color-secundary mb-3">
                  Para brindar un servicio oportuno y eficiente, por favor
                  diligencie todos los campos del formulario
                </h4>
              </div>
              <b-row>
                <b-col cols="12" class="label">
                  <b-form-group>
                    <b-form-input type="text" id="asunto" placeholder="* Asunto" v-model="novedad.asunto"
                      required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6" class="select">
                  <SelectComponet :data="Selectnovedades1" v-model="novedad.tipo" required></SelectComponet>
                </b-col>

                <b-col cols="12" md="6" class="select">
                  <SelectComponet :data="SelectPriodidad" v-model="novedad.prioridad" required></SelectComponet>
                </b-col>
                <b-col cols="12" class="select">
                  <b-form-group>
                    <b-form-textarea id="descripcion" v-model="novedad.descripcion" placeholder="* Descripción" rows="5"
                      max-rows="5" required maxlength="250"></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" md="6">
                  <p style="font-size: 15px">
                    <b>Anexos:</b>total máximo de 4 archivos, peso máximo de
                    todos los archivos 10 MB
                  </p>
                </b-col>
                <b-col cols="12" md="6">
                  <FileInput multiple @filesSel="anexos = $event"></FileInput>
                </b-col>
              </b-row>
              <div class="text-right">
                <b-button class="button-carga" style="margin: 1% 1% 2% 2%" type="reset">Borrar</b-button>
                <b-button class="button-carga" style="margin: 1% 2% 2% 1%" type="submit"
                  :disabled="this.loading">Enviar</b-button>
              </div>
            </b-form>
            <b-alert show dismissible fade variant="primary" v-if="mensaje != null" class="mt-4"
              @dismissed="showDismissibleAlertSuccess = false">
              <div class="text-center titulo-alerta-succes">{{ mensaje }}</div>
            </b-alert>

            <b-alert show dismissible fade variant="danger" v-if="error" class="mt-4"
              @dismissed="showDismissibleAlertSuccess = false">
              <div class="text-center titulo-alerta-danger">
                ¡Alerta! Ocurrió un error al registrar la novedad
              </div>
            </b-alert>
          </div>
        </b-col>

        <!-- Panel Derecho -->
        <Recomendaciones>
          <b class="color-secundary" style="font-size: 20px">Recomendaciones para el uso del área de reporte de
            novedades</b>
          <p style="font-size: 15px">
            <b>¿Qué es una novedad?</b>
            <br />Una novedad es el proceso por medio del cual se informan los
            cambios sobre las operaciones ya registradas o en proceso de
            registro. Debe tener en cuenta que algunas novedades conllevan al
            cobro de un valor de servicio de fianza adicional.
            <br />
            <b>Tipos de novedad:</b>
            <br />Existen varios tipos de novedades que deben reportarse, para
            cada una de ellas existen condiciones especiales. La novedad puede
            reportarse de manera individual o masiva adjuntando un archivo donde
            se relacionen las operaciones afectadas.
            <br />
          </p>
          <!-- <hr class="background-secundary mt-4 mb-4" />
          <SelectComponet :data="Selectnovedades1" ></SelectComponet>
          {{novedad.tipo}}
          <div>
            <div v-html="Selectnovedades1Defi[selectQueEsNovedad-1]" style="font-size: 15px;"></div>
          </div>-->
        </Recomendaciones>
      </b-row>
    </div>
  </div>
</template>
<script>
//import Selectnovedades1 from "@/data/Selectnovedades1.json";
import Selectnovedades1Defi from "@/data/Selectnovedades1Defi.json";
import SelectPriodidad from "@/data/SelectPriodidad.json";

export default {
  name: "Novedades",
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    Recomendaciones: () => import("@/containers/layout/Recomendaciones.vue"),
    FileInput: () => import("@/components/form/FileInput.vue"),
  },
  computed: {
    Selectnovedades1() {
      return this.$store.getters["pages/dataInformes"].datos;
    },
  },
  data() {
    return {
      Selectnovedades1Defi: Selectnovedades1Defi,
      SelectPriodidad: SelectPriodidad,
      novedad: {
        descripcion: null,
        asunto: null,
        tipo: null,
        prioridad: null,
      },
      //asunto: "",
      //tincidencia: null,
      Modeltincidencia: null,
      //tprioridad: null,
      //descripcion: "",
      anexos: [],
      operaciones: null,
      especialista: null,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      error: false,
      mensaje: null,
      loading: false,
    };
  },
  methods: {
    async onSubmit() {
      this.$toasted.show("Estamos procesando su solicitud", {
        theme: "toasted-primary",
        position: "top-right",
        duration: 5000,
      });

      this.loading = true;

      var axios = require("axios");
      var formData = new FormData();

      this.anexos.forEach((element, index) => {
        formData.append("archivos[]", this.anexos[index]);
      });

      //formData.set("email_test", "jaldana@fga.com.co");
      formData.set("usuario_id", this.$store.state.user.user.id);
      formData.set("fecha", this.$moment().format("YYYY-MM-DD"));
      formData.set("asunto", this.novedad.asunto);
      formData.set("descripcion", this.novedad.descripcion);
      formData.set("tipo", this.novedad.tipo);
      formData.set("prioridad", this.novedad.prioridad);
      formData.set("origen", "portal");

      try {
        /*let request = await axios.post(
          "https://portal.fga.com.co/portal/modulos/mod_report_nov/report_nov_clientes.php",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (isNaN(request.data)) {
          this.error = "Ocurrió un error en la aplicación: ".request.data;
        } else {
          this.mensaje =
            "Hemos registrado exitosamente su solicitud, el código del caso es: " +
            request.data;
        }*/
        let data = new Promise((res, rej) => {
          this.$store.getters.api
            .post("/portal/novedades", formData)
            .then((response) => {
              this.loading = false;
              res(response);
            })
            .catch((error) => {
              this.loading = false;
              rej(error);
            });
        });

        data
          .then((data) => {
            this.mensaje =
              "Hemos registrado exitosamente su solicitud, el código del caso es: " +
              data.data;
          })
          .catch((err) => {
            this.error =
              "Ocurrió un error en la aplicación al intentar registrar la novedad.";
          });
      } catch (err) {
        this.loading = false;
        this.error =
          "Ocurrió un error en la aplicación al intentar registrar la novedad.";
      }

      // this.$store.dispatch('novedad/saveNovedad', {endpoint: 'portal/novedades', params: this.novedad})
      // .then(response => {
      //   this.mensaje = response.mensaje;
      // })
      // .catch(error => {
      //   this.error = true;
      // })
    },
    onReset(evt) {
      this.novedad = {};
      this.anexos = [];
    },
  },
  mounted() {
    this.$store.dispatch("pages/fetch", {
      endpoint: "portal/tipo_novedad",
      params: {
        tipos: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 19, 22, 23, 46, 47, 71, 72, 73,
          74, 75, 76, 77, 78, 79, 80, 82, 83, 84, 85
        ],
        categoria: ["novedad"],
        paginar: "false",
      },
    });
  },
};
</script>